module.exports = __webpack_public_path__ + "static/media/downloadWhite.17682aaa.svg";